import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import {Tooltip} from "@mui/material";
import {History} from "@mui/icons-material";

import {primaryColor} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

HistoryFeedButton.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        retailer: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

function HistoryFeedButton({feed, ...props}) {
    const retailerId = feed.retailer.replace('/retailers/', '');

    return (
        <Link to={MarketplaceRoutes.RETAILER_FEEDS_HISTORY(retailerId, feed.id)} >
            <Tooltip title={<FormattedMessage id={"feed.list.table.tooltip.history"}/>}>
                <History style={{color: primaryColor , cursor: "pointer"}} />
            </Tooltip>
        </Link>
    );
}

export default HistoryFeedButton;
